var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBartrackLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 53.27 113.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -8.26,
    y1: 95.16,
    x2: 60.74,
    y2: 12.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#12ac56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09d13d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -5.41,
    y1: 91.96,
    x2: 57.85,
    y2: 16.56,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.93,39.22A81.66,81.66,0,0,0,51.8,9.08c-1-5.77-5-9-10.81-9.07-4.8,0-9.6,0-14.4,0V.07c-4.88,0-9.75,0-14.62,0a10.72,10.72,0,0,0-10.75,9A83.5,83.5,0,0,0,.88,35.36c1.71,11,3.45,22,5.69,32.85a63.92,63.92,0,0,1,.62,24.5c-.55,3-1.34,6-1.22,9.07.25,6.62,5,11.35,11.6,11.38,6.25,0,12.51-.1,18.77,0,4,.1,10.09-3.86,11-9a21,21,0,0,0-.14-7.79,74,74,0,0,1-.59-26.9C48.42,59.43,50,49.29,51.93,39.22ZM45,97.44a18.54,18.54,0,0,1,.37,4.54,8.9,8.9,0,0,1-8.86,8.46c-6.48,0-13,.14-19.43,0-6-.17-9.93-5-9.09-10.87.89-6.26,2.1-12.47,1.91-18.85C9.68,73.46,8.25,66.39,7,59.3,5.43,50,3.35,40.78,2.25,31.39a63.52,63.52,0,0,1,0-15.22c.25-1.94.2-3.91.6-5.85a9.16,9.16,0,0,1,9-7.61c4.87-.07,9.74,0,14.62,0h0c4.66,0,9.31,0,14,0,5.84,0,9.36,3.29,9.95,9.12.38,3.84.91,7.66,1.11,11.51a64.06,64.06,0,0,1-1.22,14.09c-1.67,9.83-3.16,19.7-5.24,29.43a79.07,79.07,0,0,0-1.67,16.41A64.26,64.26,0,0,0,45,97.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.82,44.46c2.07-11,3.29-22,1.11-33.15-.92-4.76-3.09-6.78-8-6.81-3.71,0-7.42,0-11.13,0-5.38,0-10.76.21-16.14.23C8,4.75,6.36,7,5.17,11.46c-.85,3.18-.83,6.62-1,10A73.43,73.43,0,0,0,5.92,38.69c1.94,9.92,3.24,20,5,29.93a78.42,78.42,0,0,1,.67,23.24c-.39,3-1.28,6-1.3,9.07,0,4.87,2.58,7.71,7.42,7.8,6.11.11,12.22.08,18.33,0a7,7,0,0,0,7-6.9,25.24,25.24,0,0,0-.63-6.07A80.63,80.63,0,0,1,42,69.5C43.21,61.07,45.24,52.81,46.82,44.46Zm-20.18,59a2.31,2.31,0,1,1,2.3-2.31A2.3,2.3,0,0,1,26.64,103.42ZM41.06,39.84c-1.6,10.72-3.75,21.34-5.14,32.08a81,81,0,0,0-.07,17.19c.31,3.53-.59,4.74-4.08,4.8-1.75,0-3.49,0-5.24,0s-3.78.06-5.66,0c-2.16-.09-3.17-1.21-3.08-3.38.06-1.81.26-3.62.39-5.43A82.71,82.71,0,0,0,16,60.62C13.83,51,12.63,41.33,11,31.67a48,48,0,0,1-.71-9.12c.09-2.93.9-3.63,3.78-3.19a78.44,78.44,0,0,0,12.34,1.25,71.93,71.93,0,0,0,12.35-1.16C42.17,18.84,43,19.51,43,23,43,28.66,41.89,34.24,41.06,39.84Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBartrackLogo);
export default __webpack_public_path__ + "static/media/bartrack_logo.48329746a2c987259f662bb8aeb630ad.svg";
export { ForwardRef as ReactComponent };